export const AUTH_STORAGE_KEY = 'smartstreet-pop-auth';

export type StoredAuthTokens = {
  access?: string | null;
  refresh?: string | null;
};

let cachedTokens: StoredAuthTokens | null = null;

export function readStoredAuthTokens(): StoredAuthTokens | null {
  if (cachedTokens) return cachedTokens;
  const stored = window.localStorage.getItem(AUTH_STORAGE_KEY);
  if (!stored) return null;
  try {
    const parsed = JSON.parse(stored) as StoredAuthTokens;
    if (parsed && typeof parsed === 'object') {
      cachedTokens = parsed;
      return parsed;
    }
  } catch {}
  return null;
}

export function writeStoredAuthTokens(tokens: StoredAuthTokens) {
  cachedTokens = tokens;
  try { window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(tokens)); } catch {}
}

export function clearStoredAuthTokens() {
  cachedTokens = null;
  try { window.localStorage.removeItem(AUTH_STORAGE_KEY); } catch {}
}
